import React, { useState, useEffect, useCallback, useContext, useRef } from 'react';
import { Button, Card, Divider, Modal, notification, Spin } from 'antd';
import UserContext from '../../../../../context/UserContext';
import { useLanguage } from '../../../../../context/LanguageContext';
import { Space, Tabs, TabsProps, Tag } from "antd";
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import SecurityService from '../../../../../services/SecurityService';
import Positions from './tab1/Positions';
import SafetyMap from './tab2/SafetyMap';
import { ClassesShow, PositionSecured, SweepSecurityShow } from '../../../../../models/Security';
import SecurityModal from './SafetyAndSecurityModal';

const SafetyAndSecurityTable = () => {
    const isMobile = useContext(UserContext).isMobile;
    const { language } = useLanguage();
    const { sweepId } = useParams();
    const [loading, setLoading] = useState(true);
    const [safetyActive, setSafetyActive] = useState<boolean>(true);
    const [sweepSecurity, setSweepSecurity] = useState<SweepSecurityShow>();
    const [classes, setClasses] = useState<ClassesShow[]>([]);
    const [searchParams, setSearchParams] = useSearchParams();
    let tabId = searchParams.get("tab") || "1";
    const navigate = useNavigate()

    const updateContent = useCallback(() => {
        if (sweepId) {
            SecurityService.checkSweepSecurity(parseInt(sweepId)).then((res) => {
                if (res === null) {
                    return
                }
                setSafetyActive(res);
                SecurityService.getSecurityClassesShow(parseInt(sweepId)).then((cls) => {
                    if (cls === null) {
                        return
                    }
                    setClasses(cls);
                })
                if (res) {
                    SecurityService.getSecuredSweep(parseInt(sweepId)).then((res) => {
                        if (res === null) {
                            return
                        }
                        setSweepSecurity(res);
                        setLoading(false);
                    }).catch((err) => {
                        console.error(err);
                        setLoading(false);
                    });
                }
            })
        }
    }, [sweepId, navigate]);

    useEffect(() => {
        updateContent();
        const interval = setInterval(() => {
            updateContent();
        }, 60000);
        return () => clearInterval(interval);
    }, [updateContent]);


    const handleCancel = () => {
        navigate("/security");
        setSafetyActive(false);
    };


    const tabs: TabsProps["items"] = [
        {
            key: "1",
            label: language === "es" ? "Resumen" : "Summary",
            children: sweepSecurity === undefined ? (<></>) : (
                <Positions positionSecured={sweepSecurity.positions} classes={classes}/>
            )
        },
        {
            key: "2",
            label: language === "es" ? "Mapa" : "Map",
            children: sweepSecurity === undefined ? (<></>) :
                (
                    <SafetyMap onUpdateContent={updateContent} warehouseIdx={sweepSecurity.warehouseIdx} sweep={sweepSecurity} />
                )
        }
    ];
    return (
        <Spin spinning={loading}>
            <Card title={language === "es" ? "Seguridad y Protección" : "Safety and Security"}
                style={{
                    margin: isMobile ? '10px' : '20px',
                    padding: isMobile ? '10px' : '20px',
                }}>
                {sweepId ? <SecurityModal sweepId={sweepId} isVisible={safetyActive} onClose={handleCancel} setVisible={setSafetyActive} updateContent={updateContent} /> : <></>}
                <Tabs
                    destroyInactiveTabPane={true}
                    items={tabs}
                    activeKey={tabId}
                    onTabClick={(activeKey) => {
                        setSearchParams({ tab: activeKey });
                    }}
                />
            </Card>
        </Spin>
    );
};

export default SafetyAndSecurityTable;
